var link_viewer_default = {
  "fontElementMap": "FqdN1",
  "link": "_1PQTo",
  "linkInEditor": "KHeQY",
  "linkInViewer": "g-YLf",
  "toolbarUrlContainer": "IuikN",
  "toolbarUrl": "_28HB8",
  "toolbarUrlAnchor": "qj4tO"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
